import { currencyFormat, dateFormat } from '../utils/formatter'

export const payrollDistributionCols = [
  {
    accessorKey: 'COMPANY',
    header: 'Company',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  },
  {
    accessorKey: 'DIST_COMPANY',
    header: 'Dist Company',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  },
  {
    accessorKey: 'DST_ACCT_UNIT',
    header: 'Acct Unit',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  },
  {
    accessorKey: 'DST_ACCOUNT',
    header: 'Acct',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  },
  {
    accessorKey: 'DST_SUB_ACCT',
    header: 'Sub Acct',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  },
  {
    accessorKey: 'DST_CO_CURR_CD',
    header: 'Currency Code',
    enableSorting: false,
    enableColumnFilter: false,
    size: 1
  },
  {
    accessorKey: 'CHECK_NBR',
    header: 'Check Number',
    enableSorting: true,
    enableColumnFilter: true,
    size: 1
  },
  {
    accessorKey: 'PROCESS_LEVEL',
    header: 'Process Level',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  },
  {
    accessorKey: 'EMPLOYEE',
    header: 'Employee',
    enableSorting: true,
    enableColumnFilter: true,
    size: 1
  },
  {
    accessorKey: 'DEPARTMENT',
    header: 'Department',
    enableSorting: true,
    enableColumnFilter: true,
    size: 1
  },
  {
    accessorKey: 'DED_CDOE',
    header: 'Deduction Code',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  },
  {
    accessorKey: 'PAY_CODE',
    header: 'Pay Code',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  },
  {
    accessorKey: 'PAY_UNITS',
    header: 'Pay Units',
    enableSorting: true,
    enableColumnFilter: false,
    size: 1
  },
  {
    accessorKey: 'HOURS',
    header: 'Hours',
    enableSorting: true,
    enableColumnFilter: false,
    size: 1
  },
  {
    accessorKey: 'DIST_AMT',
    header: 'Distribution Amount',
    enableSorting: true,
    enableColumnFilter: false,
    size: 1,
    Cell: ({ cell }) => currencyFormat(cell.getValue())
  },
  {
    accessorKey: 'GL_DATE',
    header: 'GL Date',
    enableSorting: false,
    enableColumnFilter: false,
    size: 1,
    Cell: ({ cell }) => dateFormat(cell.getValue())
  },
  {
    accessorKey: 'POSITION',
    header: 'Position',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  },
  {
    accessorKey: 'CHECK_TYPE',
    header: 'Check Type',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  },
  {
    accessorKey: 'ACTIVITY',
    header: 'Activity',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  },
  {
    accessorKey: 'ACCT_CATEGORY',
    header: 'Account Category',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  },
  {
    accessorKey: 'JOB_CODE',
    header: 'Job Code',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  }
] 